<template>
  <div class="modal fade" id="delete-role-modal" role="dialog">
    <div class="modal-dialog mx-auto">
      <div class="modal-content p-[24px] bg-[#fff]">
        <div class="modal-body m-0 p-0">
          <h4
            class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
          >
            Caution
          </h4>
          <p class="text-[#353535] text-[16px] font-normal leading-[20px]">
            Are you sure you want to delete this role?
          </p>
        </div>
        <div class="flex items-center gap-[8px] mt-[16px]">
          <button
            class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] md:px-[24px] rounded-[8px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
            type="button"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            class="bg-[#DC2828] border-[#DC2828] border-solid border py-[16px] md:px-[24px] rounded-[8px] rounded-[8px] w-full"
            type="button"
            @click="confirmDelete"
          >
            <span
              v-if="isLoading"
              class="cursor-not-allowed text-white text-[14px] md:text-[16px] font-medium leading-[20px] "
              >Busy...</span
            >
            <span
              class="text-white text-[14px] md:text-[16px] font-medium leading-[20px] "
              v-else
              >Delete</span
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";

export default {
  name: "DeleteRoleModal",
  props: ["roleId", "role"],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async confirmDelete() {
      try {
        this.isLoading = true;

        const roleType =
          this.role.roleType === "Office"
            ? "business"
            : this.role.roleType === "SalesForce"
            ? "sales"
            : "default";

        if (!roleType || !this.roleId) {
          throw new Error("Invalid role type or role ID");
        }
        const url =
          roleType === "business"
            ? `/Roles/delete/${this.roleId}`
            : roleType === "sales"
            ? `/SalesRoles/delete/${this.roleId}`
            : `/Roles/delete/${this.roleId}`; // Default URL
        await this.$http.post(url);
        this.$emit("deletion-success");
        bus.$emit("getroles");
      } catch (error) {
        console.error("Error deleting the role:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
